// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-6fd7ce81]{cursor:pointer}.visible-content[data-v-6fd7ce81]{border-left:4px solid #187cc6}.collapse[data-v-6fd7ce81]{padding-left:20px}", ""]);
// Exports
module.exports = exports;
